const secondsToMinutes = (seconds: number) => {
  const minutes = Math.floor(seconds / 60);
  const secondsRemaining = seconds - minutes * 60;

  return `${('0' + minutes).slice(-2)}:${('0' + secondsRemaining).slice(-2)}`;
};

export default secondsToMinutes;
